import type { Category, CollectionSlug, FitnessCategory, Product } from '../types';

export const collections: Array<{ slug: CollectionSlug; name: string; statement: string }> = [
  {
    slug: 'fitness',
    name: 'Fitness',
    statement: 'Peças para acompanhar o seu ritmo, com leveza e atitude.',
  },
  {
    slug: 'moda-praia',
    name: 'Moda Praia',
    statement: 'Em breve, uma curadoria pensada para brilhar sob o sol.',
  },
  {
    slug: 'lingerie',
    name: 'Lingerie',
    statement: 'Conforto delicado e renda para valorizar todos os momentos.',
  },
];

export const fitnessCategories: Array<{ slug: FitnessCategory; name: string }> = [
  { slug: 'conjuntos', name: 'Conjuntos' },
  { slug: 'tops', name: 'Tops' },
  { slug: 'shorts-bermudas', name: 'Shorts e Bermudas' },
  { slug: 'leggings-calcas', name: 'Leggings e Calças' },
  { slug: 'macacoes', name: 'Macacões' },
  { slug: 'camisetas', name: 'Camisetas' },
  { slug: 'jaquetas', name: 'Jaquetas' },
];

export const categorySeed: Category[] = [
  { id: 'fitness', name: 'Fitness', slug: 'fitness', collection: 'fitness', active: true },
  ...fitnessCategories.map((category) => ({
    id: `fitness-${category.slug}`,
    name: category.name,
    slug: category.slug,
    collection: 'fitness' as const,
    parentId: 'fitness',
    active: true,
  })),
  { id: 'moda-praia', name: 'Moda Praia', slug: 'moda-praia', collection: 'moda-praia', active: true },
  { id: 'moda-praia-biquinis', name: 'Biquínis', slug: 'biquinis', collection: 'moda-praia', parentId: 'moda-praia', active: true },
  { id: 'moda-praia-maios', name: 'Maiôs', slug: 'maios', collection: 'moda-praia', parentId: 'moda-praia', active: true },
  { id: 'moda-praia-saidas', name: 'Saídas de Praia', slug: 'saidas-de-praia', collection: 'moda-praia', parentId: 'moda-praia', active: true },
  { id: 'moda-praia-acessorios', name: 'Acessórios', slug: 'acessorios', collection: 'moda-praia', parentId: 'moda-praia', active: true },
  { id: 'lingerie', name: 'Lingerie', slug: 'lingerie', collection: 'lingerie', active: true },
  { id: 'lingerie-conjuntos', name: 'Conjuntos', slug: 'conjuntos', collection: 'lingerie', parentId: 'lingerie', active: true },
  { id: 'lingerie-sutias', name: 'Sutiãs', slug: 'sutias', collection: 'lingerie', parentId: 'lingerie', active: true },
  { id: 'lingerie-calcinhas', name: 'Calcinhas', slug: 'calcinhas', collection: 'lingerie', parentId: 'lingerie', active: true },
  { id: 'lingerie-bodies', name: 'Bodies', slug: 'bodies', collection: 'lingerie', parentId: 'lingerie', active: true },
];

const provisional = {
  price: null,
  sizes: ['P', 'M', 'G', 'GG'],
  active: true,
  provisional: true,
  description: null,
  details: null,
  composition: null,
  care: null,
};

export const catalogProducts: Product[] = [
  {
    ...provisional,
    id: 'conjunto-cloud-azul',
    name: 'Conjunto Cloud Azul',
    slug: 'conjunto-cloud-azul',
    collection: 'fitness',
    category: 'conjuntos',
    tags: ['conjuntos', 'tops', 'shorts-bermudas'],
    colors: [{ name: 'Azul claro', hex: '#a9d8f6' }],
    images: [{ id: '1204', alt: 'Conjunto azul claro Cloud da Sena Beachway' }],
    price: 139.99,
    provisional: false,
    featured: true,
    newProduct: true,
    createdAt: '2026-08-01',
  },
  {
    ...provisional,
    id: 'conjunto-rib-grafite',
    name: 'Conjunto Rib Grafite',
    slug: 'conjunto-rib-grafite',
    collection: 'fitness',
    category: 'conjuntos',
    tags: ['conjuntos', 'tops', 'shorts-bermudas'],
    colors: [{ name: 'Grafite', hex: '#676163' }],
    images: [{ id: '1279', alt: 'Conjunto canelado grafite da Sena Beachway' }],
    price: 119.99,
    provisional: false,
    bestSeller: true,
    createdAt: '2026-07-28',
  },
  {
    ...provisional,
    id: 'conjunto-aura-lilas',
    name: 'Conjunto Aura Lilás',
    slug: 'conjunto-aura-lilas',
    collection: 'fitness',
    category: 'conjuntos',
    tags: ['conjuntos', 'tops', 'shorts-bermudas'],
    colors: [{ name: 'Lilás', hex: '#d5c7e9' }],
    images: [{ id: '1308', alt: 'Conjunto lilás Aura da Sena Beachway' }],
    price: 139.99,
    provisional: false,
    newProduct: true,
    createdAt: '2026-08-03',
  },
  {
    ...provisional,
    id: 'conjunto-serenity-azul',
    name: 'Conjunto Serenity Azul',
    slug: 'conjunto-serenity-azul',
    collection: 'fitness',
    category: 'conjuntos',
    tags: ['conjuntos', 'tops', 'shorts-bermudas'],
    colors: [{ name: 'Azul serenity', hex: '#9fcdf3' }],
    images: [{ id: '1322', alt: 'Conjunto azul Serenity da Sena Beachway' }],
    price: 99.99,
    provisional: false,
    featured: true,
    createdAt: '2026-08-02',
  },
  {
    ...provisional,
    id: 'conjunto-move-preto',
    name: 'Conjunto Move Preto',
    slug: 'conjunto-move-preto',
    collection: 'fitness',
    category: 'conjuntos',
    tags: ['conjuntos', 'tops', 'shorts-bermudas'],
    colors: [{ name: 'Preto', hex: '#121212' }],
    images: [{ id: '1358', alt: 'Conjunto preto Move da Sena Beachway' }],
    price: 119.99,
    provisional: false,
    bestSeller: true,
    createdAt: '2026-07-20',
  },
  {
    ...provisional,
    id: 'macacao-marinho-line',
    name: 'Macacão Marinho Line',
    slug: 'macacao-marinho-line',
    collection: 'fitness',
    category: 'macacoes',
    tags: ['macacoes'],
    colors: [{ name: 'Azul marinho', hex: '#121d43' }],
    images: [
      { id: '1396', alt: 'Macacão azul marinho Line da Sena Beachway, frente' },
      { id: '1411', alt: 'Macacão azul marinho Line da Sena Beachway, costas' },
      { id: '1555', alt: 'Macacão azul marinho Line da Sena Beachway em detalhe' },
    ],
    price: 89.99,
    provisional: false,
    featured: true,
    bestSeller: true,
    createdAt: '2026-08-04',
  },
  {
    ...provisional,
    id: 'conjunto-terra-essencial',
    name: 'Conjunto Terra Essencial',
    slug: 'conjunto-terra-essencial',
    collection: 'fitness',
    category: 'conjuntos',
    tags: ['conjuntos'],
    colors: [{ name: 'Terra', hex: '#683d42' }, { name: 'Branco', hex: '#f4f1eb' }],
    images: [
      { id: '1423', alt: 'Conjunto Terra Essencial da Sena Beachway em pose sentada' },
      { id: '1430', alt: 'Conjunto Terra Essencial da Sena Beachway' },
    ],
    price: 159.99,
    provisional: false,
    createdAt: '2026-08-01',
  },
  {
    ...provisional,
    id: 'conjunto-pink-air',
    name: 'Conjunto Pink Air',
    slug: 'conjunto-pink-air',
    collection: 'fitness',
    category: 'conjuntos',
    tags: ['conjuntos'],
    colors: [{ name: 'Pink', hex: '#ee7195' }, { name: 'Branco', hex: '#f5f3ef' }],
    images: [
      { id: '1234', alt: 'Conjunto Pink Air da Sena Beachway' },
      {
        id: 'pink-air-frente',
        alt: 'Conjunto Pink Air da Sena Beachway em vista frontal',
        url: '/images/fitness/conjunto-pink-air-frente.jpeg',
      },
    ],
    price: 119.99,
    provisional: false,
    newProduct: true,
    createdAt: '2026-08-12',
  },
  {
    ...provisional,
    id: 'legging-terra-essencial',
    name: 'Legging Terra Essencial',
    slug: 'legging-terra-essencial',
    collection: 'fitness',
    category: 'leggings-calcas',
    tags: ['leggings-calcas'],
    colors: [{ name: 'Terra', hex: '#683d42' }],
    images: [{ id: '1423', alt: 'Legging Terra Essencial da Sena Beachway' }],
    price: 109.99,
    provisional: false,
    createdAt: '2026-08-01',
  },
  {
    ...provisional,
    id: 'conjunto-lilas-air',
    name: 'Conjunto Lilás Air',
    slug: 'conjunto-lilas-air',
    collection: 'fitness',
    category: 'conjuntos',
    tags: ['conjuntos'],
    colors: [{ name: 'Lilás', hex: '#886ce1' }, { name: 'Areia', hex: '#eee6d9' }],
    images: [
      { id: '1437', alt: 'Conjunto Lilás Air da Sena Beachway, lateral' },
      { id: '1440', alt: 'Conjunto Lilás Air da Sena Beachway, frente' },
    ],
    price: 159.99,
    provisional: false,
    newProduct: true,
    createdAt: '2026-08-05',
  },
  {
    ...provisional,
    id: 'legging-air-off-white',
    name: 'Legging Air Off-white',
    slug: 'legging-air-off-white',
    collection: 'fitness',
    category: 'leggings-calcas',
    tags: ['leggings-calcas'],
    colors: [{ name: 'Off-white', hex: '#eee6d9' }],
    images: [{ id: '1437', alt: 'Legging Air off-white da Sena Beachway' }],
    price: 109.99,
    provisional: false,
    newProduct: true,
    createdAt: '2026-08-05',
  },
  {
    ...provisional,
    id: 'camiseta-air-rosa',
    name: 'Camiseta Air Rosa',
    slug: 'camiseta-air-rosa',
    collection: 'fitness',
    category: 'camisetas',
    tags: ['camisetas'],
    colors: [{ name: 'Rosa suave', hex: '#f6dbe4' }],
    images: [{ id: '1459', alt: 'Camiseta rosa Air da Sena Beachway' }],
    price: 49.99,
    provisional: false,
    createdAt: '2026-07-25',
  },
  {
    ...provisional,
    id: 'camiseta-air-areia',
    name: 'Camiseta Air Areia',
    slug: 'camiseta-air-areia',
    collection: 'fitness',
    category: 'camisetas',
    tags: ['camisetas'],
    colors: [{ name: 'Areia', hex: '#e6d0ba' }],
    images: [{ id: '1471', alt: 'Camiseta areia Air da Sena Beachway' }],
    price: 49.99,
    provisional: false,
    createdAt: '2026-07-24',
  },
  {
    ...provisional,
    id: 'jaqueta-flow-off-white',
    name: 'Jaqueta Flow Off-white',
    slug: 'jaqueta-flow-off-white',
    collection: 'fitness',
    category: 'jaquetas',
    tags: ['jaquetas'],
    colors: [{ name: 'Off-white', hex: '#e8e4dd' }, { name: 'Azul marinho', hex: '#17244c' }],
    images: [
      { id: '1479', alt: 'Jaqueta Flow off-white da Sena Beachway' },
      { id: '1479-lifestyle', alt: 'Jaqueta Flow off-white da Sena Beachway, editorial', url: '/images/fitness/jaqueta-flow-1479-lifestyle-720.webp', largeUrl: '/images/fitness/jaqueta-flow-1479-lifestyle-1280.webp' },
    ],
    price: 69.99,
    provisional: false,
    featured: true,
    createdAt: '2026-08-06',
  },
  {
    ...provisional,
    id: 'conjunto-flow-azul',
    name: 'Conjunto Flow Azul',
    slug: 'conjunto-flow-azul',
    collection: 'fitness',
    category: 'conjuntos',
    tags: ['conjuntos'],
    colors: [{ name: 'Azul marinho', hex: '#17244c' }, { name: 'Off-white', hex: '#e8e4dd' }],
    images: [
      { id: '1479', alt: 'Conjunto Flow azul da Sena Beachway' },
      { id: '1479-lifestyle', alt: 'Conjunto Flow azul da Sena Beachway, editorial', url: '/images/fitness/jaqueta-flow-1479-lifestyle-720.webp', largeUrl: '/images/fitness/jaqueta-flow-1479-lifestyle-1280.webp' },
    ],
    price: 119.99,
    provisional: false,
    featured: true,
    createdAt: '2026-08-06',
  },
  {
    ...provisional,
    id: 'jaqueta-noir-preta',
    name: 'Jaqueta Noir Preta',
    slug: 'jaqueta-noir-preta',
    collection: 'fitness',
    category: 'jaquetas',
    tags: ['jaquetas'],
    colors: [{ name: 'Preto', hex: '#111111' }],
    images: [{ id: '6170', alt: 'Jaqueta Noir preta da Sena Beachway', url: '/images/fitness/jaqueta-noir-720.webp', largeUrl: '/images/fitness/jaqueta-noir-1280.webp' }],
    price: 69.99,
    provisional: false,
    newProduct: true,
    createdAt: '2026-08-12',
  },
  {
    ...provisional,
    id: 'macacao-noir',
    name: 'Macacão Noir',
    slug: 'macacao-noir',
    collection: 'fitness',
    category: 'macacoes',
    tags: ['macacoes'],
    colors: [{ name: 'Preto', hex: '#111111' }],
    images: [
      { id: '1524', alt: 'Macacão preto Noir da Sena Beachway, frente' },
      { id: '1526', alt: 'Macacão preto Noir da Sena Beachway, lateral' },
    ],
    price: 109.99,
    provisional: false,
    newProduct: true,
    bestSeller: true,
    createdAt: '2026-08-08',
  },
  {
    ...provisional,
    id: 'camiseta-core-grafite',
    name: 'Camiseta Core Grafite',
    slug: 'camiseta-core-grafite',
    collection: 'fitness',
    category: 'camisetas',
    tags: ['camisetas', 'shorts-bermudas'],
    colors: [{ name: 'Grafite', hex: '#766e76' }],
    images: [{ id: '1540', alt: 'Camiseta grafite Core da Sena Beachway' }],
    price: 49.99,
    provisional: false,
    createdAt: '2026-07-19',
  },
  {
    ...provisional,
    id: 'camiseta-essentials-preta',
    name: 'Camiseta Essentials Preta',
    slug: 'camiseta-essentials-preta',
    collection: 'fitness',
    category: 'camisetas',
    tags: ['camisetas'],
    colors: [{ name: 'Preto', hex: '#161616' }],
    images: [{ id: '1567', alt: 'Camiseta Essentials preta da Sena Beachway' }],
    price: 49.99,
    provisional: false,
    createdAt: '2026-08-07',
  },
  {
    ...provisional,
    id: 'conjunto-black-essentials',
    name: 'Conjunto Black Essentials',
    slug: 'conjunto-black-essentials',
    collection: 'fitness',
    category: 'conjuntos',
    tags: ['conjuntos', 'shorts-bermudas'],
    colors: [{ name: 'Preto', hex: '#161616' }],
    images: [{ id: '1567', alt: 'Conjunto Black Essentials da Sena Beachway' }],
    price: 119.98,
    provisional: false,
    createdAt: '2026-08-07',
  },
  {
    ...provisional,
    id: 'camiseta-evolution-preta',
    name: 'Camiseta Evolution Preta',
    slug: 'camiseta-evolution-preta',
    collection: 'fitness',
    category: 'camisetas',
    tags: ['camisetas'],
    colors: [{ name: 'Preto', hex: '#111111' }],
    images: [{ id: '1582', alt: 'Camiseta Evolution preta da Sena Beachway' }],
    price: 49.99,
    provisional: false,
    bestSeller: true,
    createdAt: '2026-07-30',
  },
  {
    ...provisional,
    id: 'legging-evolution-preta',
    name: 'Legging Evolution Preta',
    slug: 'legging-evolution-preta',
    collection: 'fitness',
    category: 'leggings-calcas',
    tags: ['leggings-calcas'],
    colors: [{ name: 'Preto', hex: '#111111' }],
    images: [{ id: '1582', alt: 'Legging Evolution preta da Sena Beachway' }],
    price: 109.99,
    provisional: false,
    bestSeller: true,
    createdAt: '2026-07-30',
  },
  {
    ...provisional,
    id: 'conjunto-renda-preto',
    name: 'Conjunto Renda Preto',
    slug: 'conjunto-renda-preto',
    collection: 'lingerie',
    category: 'conjuntos',
    tags: ['conjuntos', 'sutias', 'calcinhas'],
    colors: [{ name: 'Preto', hex: '#111111' }],
    images: [{
      id: 'renda-preto',
      alt: 'Conjunto de lingerie em renda preta da Sena Beachway',
      url: '/images/lingerie/conjunto-renda-preto-720.webp',
      largeUrl: '/images/lingerie/conjunto-renda-preto-1280.webp',
    }],
    featured: true,
    newProduct: true,
    createdAt: '2026-08-11',
  },
  {
    ...provisional,
    id: 'conjunto-renda-branco',
    name: 'Conjunto Renda Branco',
    slug: 'conjunto-renda-branco',
    collection: 'lingerie',
    category: 'conjuntos',
    tags: ['conjuntos', 'sutias', 'calcinhas'],
    colors: [{ name: 'Branco', hex: '#f7f5f0' }],
    images: [{
      id: 'renda-branco',
      alt: 'Conjunto de lingerie em renda branca da Sena Beachway',
      url: '/images/lingerie/conjunto-renda-branco-720.webp',
      largeUrl: '/images/lingerie/conjunto-renda-branco-1280.webp',
    }],
    newProduct: true,
    createdAt: '2026-08-11',
  },
  {
    ...provisional,
    id: 'conjunto-renda-azul',
    name: 'Conjunto Renda Azul',
    slug: 'conjunto-renda-azul',
    collection: 'lingerie',
    category: 'conjuntos',
    tags: ['conjuntos', 'sutias', 'calcinhas'],
    colors: [{ name: 'Azul claro', hex: '#8cb6d5' }],
    images: [{
      id: 'renda-azul',
      alt: 'Conjunto de lingerie em renda azul da Sena Beachway',
      url: '/images/lingerie/conjunto-renda-azul-720.webp',
      largeUrl: '/images/lingerie/conjunto-renda-azul-1280.webp',
    }],
    newProduct: true,
    createdAt: '2026-08-11',
  },
];

export const categoryName = (slug: string) =>
  fitnessCategories.find((category) => category.slug === slug)?.name ?? slug;
